import React, { Suspense, lazy } from 'react';
import { ConfigProvider, App as AntdApp } from 'antd';
import roRO from 'antd/locale/ro_RO';
import RequireUser from './contexts/RequireUser'; 
import FullScreenLoader from './components/FullScreeenLoader';
import { Routes, Route } from 'react-router-dom';
import { PERMISSIONS } from './config/permissions';

import NotFoundPage from "./pages/commonpages/nopage";
import HomePage from "./pages/commonpages/HomePage";
import NoAccess from './pages/commonpages/NoAccess';
import LoginPage from './pages/commonpages/LoginPage';
import AboutPage from './pages/commonpages/AboutPage';
import ClientOfferts from './pages/dashboard/modules/Oferte/ClientOfferts';

import FurnizorPage from './pages/dashboard/modules/Livrari/FurnizorPage/FurnizorPage';
import { Financiar, Logistica, Oferte, Achizitii } from './pages/dashboard/modules';

const Dashboard = lazy(() => import("./pages/dashboard/commondash/Dashboard"));
const DashboardHome = lazy(() => import("./pages/dashboard/modules/DashHome/DashboardHome"));
const GeneralSettings = lazy(() => import("./pages/dashboard/Settings/GeneralSettings"));
const Logs = lazy(() => import("./pages/dashboard/modules/DashHome/Logs/Logs"));


const OfertaPage = lazy(() => import("./pages/dashboard/modules/Oferte/OfertaPage/OfertaPage"));

// Crearea unui obiect pentru componente lazy
// 1 - ADMIN , 2 - MANAGER, 3 - Contabil, 4 - Logistic, 5 - Furnizor
// Dashboard principal (logs și setări) - doar pentru ADMIN
// Alte module dashboard - roluri specifice conform permisiunilor

function App() {
  return (
    <ConfigProvider 
      locale={roRO}
      theme={{
        token: {
          borderRadius: 8,
        },
        components: {
          Message: {
            zIndexPopup: 99999,
          },
          Modal: {
            zIndexPopupBase: 1000,
          },
        },
      }}
    >
      <AntdApp>
        <Suspense fallback={<FullScreenLoader />}>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/noaccess" element={<NoAccess />} />
            
            {/* Pagina Furnizor - Acces pentru ADMIN, FURNIZOR și LOGISTIC */}
            <Route element={<RequireUser allowedRoles={PERMISSIONS.FURNIZORI} />}>
              <Route path="/furnizorpage/:furnizor_id" element={<FurnizorPage />} />
            </Route>

            {/* Dashboard pentru DOAR ADMINI - logs și setări generale */}
            <Route element={<RequireUser allowedRoles={PERMISSIONS.ADMIN} />}>
              <Route path="/dashboard" element={<Dashboard />}>
                <Route index element={<DashboardHome />} />
                <Route path="settings" element={<GeneralSettings />} />
                <Route path="logs" element={<Logs />} />
              </Route>
            </Route>

            {/* Financiar - Acces pentru ADMIN, CONTABIL și cei cu permisiuni LIVRARI */}
            <Route element={<RequireUser allowedRoles={[...PERMISSIONS.FINANCIAR, ...PERMISSIONS.LIVRARI]} />}>
              <Route path="/dashboard" element={<Dashboard />}>
                <Route path="financiar" element={<Financiar />} />
              </Route>
            </Route>

            {/* Livrări/Logistică - Acces pentru ADMIN, MANAGER și LOGISTIC */}
            <Route element={<RequireUser allowedRoles={PERMISSIONS.LIVRARI} />}>
              <Route path="/dashboard" element={<Dashboard />}>
                <Route path="logistica" element={<Logistica />} />
                <Route path="logistica/:tab" element={<Logistica />} />
              </Route>
            </Route>

            {/* Oferte - Acces pentru ADMIN, MANAGER și LOGISTIC */}
            <Route element={<RequireUser allowedRoles={PERMISSIONS.OFERTE} />}>
              <Route path="/dashboard" element={<Dashboard />}>
                <Route path="oferte" element={<Oferte />} />
                <Route path="oferte/:oferta_id" element={<OfertaPage />} />
                <Route path="oferte/client/:client_mongo_id" element={<ClientOfferts />} />
              </Route>
            </Route>

            {/* Achiziții - Acces pentru ADMIN, MANAGER și LOGISTIC */}
            <Route element={<RequireUser allowedRoles={PERMISSIONS.ACHIZITII} />}>
              <Route path="/dashboard" element={<Dashboard />}>
                <Route path="achizitii" element={<Achizitii />} />
                <Route path="achizitii/:tab" element={<Achizitii />} />
                <Route path="achizitii/furnizor/:furnizor_id" element={<FurnizorPage />} />
              </Route>
            </Route>

            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;